// // components/TopBar.js
// import React, { useEffect, useRef, useState } from "react";
// import {
//   Search,
//   Bell,
//   Calendar,
//   Filter,
//   Download,
//   User,
//   ChevronDown,
//   Menu,
//   X,
//   ChevronUp,
// } from "lucide-react";
// import { ChevronRight, ChevronLeft, Settings, LogOut } from "lucide-react";

// import "../../styles/topbar.css";
// import { Navigate, useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import logo from "../../assets/logo.png";
// import { students_profile, update_profile } from "../../util/Apiendpoits";
// import { getWithTokenAPI } from "../../util/Api";
// import { setProfileData } from "../../store/profileSlice";
// import NotificationsPanel from "./Notifications";
// const TopBar = ({
//   toggleSidebar,
//   isSidebarCollapsed,
//   showMobileMenu,
//   setShowMobileMenu,
// }) => {
//   const [showUserMenu, setShowUserMenu] = useState(false);
//   const { token, roleType, userId } = useSelector((state) => state.auth);
//   const state = useSelector((state) => state.auth);
//   const [Institutionprofile, setInstitutionprofile] = useState(null);

//   const Navigate = useNavigate();
//   const currentDate = new Date().toLocaleDateString("en-US", {
//     weekday: "long",
//     year: "numeric",
//     month: "long",
//     day: "numeric",
//   });

//   const [notifications, setNotifications] = useState([
//     {
//       id: 1,
//       type: "student",
//       title: "New Student",
//       message: "A new student has registered",
//       time: "2 mins ago",
//       read: false,
//     },
//     {
//       id: 2,
//       type: "payment",
//       title: "Payment Received",
//       message: "₹500 payment successful",
//       time: "1 hour ago",
//       read: false,
//     },
//   ]);

//   const [showNotifications, setShowNotifications] = useState(false);
//   const notificationsRef = useRef(null);
//   const unreadCount = notifications.filter(n => !n.read).length;

//   const handleMarkAsRead = (id) => {
//     setNotifications(prev =>
//       prev.map(n =>
//         n.id === id ? { ...n, read: true } : n
//       )
//     );
//   };

//   const handleMarkAllAsRead = () => {
//     setNotifications(prev =>
//       prev.map(n => ({ ...n, read: true }))
//     );
//   };

//   const handleCloseNotifications = () => {
//     setShowNotifications(false);
//   };

//   useEffect(() => {
//     if (roleType !== "institution_admin") return;

//     const fetchProfile = async () => {
//       try {
//         const updateRes = await getWithTokenAPI(
//           token,
//           `${students_profile}${userId}`,
//         );

//         if (updateRes?.statusCode === 200) {
//           setInstitutionprofile(updateRes.data);
//         }
//       } catch (error) {
//         console.log("Failed to update phone number");
//       }
//     };

//     fetchProfile();
//   }, [roleType, token, userId]);

//   const dispatch = useDispatch();
//   const fetchAdminProfile = async () => {
//     const res = await getWithTokenAPI(token, `${students_profile}${userId}`);
//     if (res?.statusCode === 200) {
//       dispatch(
//         setProfileData({
//           name: res.data.name,
//           phone: res.data.phoneNumber,
//           role: res.data.roleType,
//           price: res.data.adminPrice,
//           profileImage: res.data.profile_img,
//         }),
//       );
//     }
//   };
//   useEffect(() => {
//     fetchAdminProfile();
//   }, []);

//   const profile = useSelector((state) => state.profile);

//   return (
//     <header
//       className="topbar"
//       style={{
//         marginLeft: isSidebarCollapsed ? "60px" : "280px",
//         transition: "margin-left 0.3s",
//       }}
//     >
//       {Institutionprofile?.nameofInstitution && (
//         <div>
//           <p className="institution-title-topbar">
//             {Institutionprofile?.nameofInstitution}
//           </p>
//         </div>
//       )}
//       <div className="topbar-left">
//         <div className="search-wrapper">
//           <div className="search-box-top">
//             <Search size={18} className="search-icon" />
//             <input
//               type="text"
//               placeholder="Search here..."
//               className="search-input"
//             />
//           </div>
//         </div>
//       </div>

//       <div className="topbar-right">
//         {roleType === "superadmin" ? (
//           <div className="user-profile-wrapper">
//             <button
//               className="user-profile-btn"
//               onClick={() => Navigate("/profile")}
//             >
//               <div className="user-avatar">
//                 {profile?.profileImage ? (
//                   <img
//                     src={profile?.profileImage}
//                     alt="Profile"
//                     className="user-profile-image"
//                   />
//                 ) : (
//                   <User size={20} />
//                 )}
//               </div>

//               <div className="user-info">
//                 <span className="user-name">{profile?.name || "Admin"}</span>
//                 <span className="user-role">{profile.role}</span>
//               </div>
//               {showUserMenu ? (
//                 <ChevronUp size={16} className="user-info-icons" />
//               ) : (
//                 <ChevronDown size={16} className="user-info-icons" />
//               )}
//             </button>
//           </div>
//         ) : (
//           <div className="notification-institution">
//             <div className="notification-wrapper">
//               <button className="notification-btn" onClick={() => setShowNotifications(true)}>
//                 <Bell size={20} />
//                 {unreadCount > 0 && (
//                   <span className="notification-badge"></span>
//                 )}
//               </button>
//             </div>
//             <img src={logo} alt="Logo" className="custom-user-logo" />
//           </div>
//         )}

//         <div className={`notifications-panel ${showNotifications ? "open" : ""}`}>

//           <NotificationsPanel
//             ref={notificationsRef}
//             notifications={notifications}
//             unreadCount={unreadCount}
//             onMarkAsRead={handleMarkAsRead}
//             onMarkAllAsRead={handleMarkAllAsRead}
//             onClose={handleCloseNotifications}
//           />
//       </div>

//     </div>
//     </header >
//   );
// };

// export default TopBar;

// components/TopBar.js
import React, { useEffect, useRef, useState } from "react";
import { Search, Bell, User, ChevronDown, ChevronUp } from "lucide-react";

import "../../styles/topbar.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../assets/logo.png";
import { notification_list, students_profile } from "../../util/Apiendpoits";
import { getWithTokenAPI, putWithTokenAPI } from "../../util/Api";
import { setProfileData } from "../../store/profileSlice";
import NotificationsPanel from "./Notifications";

const TopBar = ({
  toggleSidebar,
  isSidebarCollapsed,
  showMobileMenu,
  setShowMobileMenu,
}) => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const { token, roleType, userId } = useSelector((state) => state.auth);
  const [Institutionprofile, setInstitutionprofile] = useState(null);
  const [showNotifications, setShowNotifications] = useState(false);
  const notificationBtnRef = useRef(null);
  const panelRef = useRef(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [notifications, setNotifications] = useState([]);

  const formatTimeAgo = (date) => {
    const now = new Date();
    const created = new Date(date);
    const diff = Math.floor((now - created) / 1000);

    if (diff < 60) return "Just now";
    if (diff < 3600) return `${Math.floor(diff / 60)} mins ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} hours ago`;
    return `${Math.floor(diff / 86400)} days ago`;
  };

  const unreadCount = notifications.filter(n => !n.read).length;
  useEffect(() => {
    const fetchNotification = async () => {
      try {
        const response = await getWithTokenAPI(
          token,
          `${notification_list}/${userId}`
        );

        const apiData = response.data || [];

        const formattedNotifications = apiData.map((item, index) => ({
          id: item._id || index,
          type: item?.type,
          title: item?.heading?.en,
          message: item?.content?.en || "",
          time: formatTimeAgo(item.createdAt),
          read: item?.is_read,
          redirectPath: item?.redirect_path,
        }));

        setNotifications(formattedNotifications);
      } catch (error) {
        console.error("Notification fetch error:", error);
      }
    };

    fetchNotification();
  }, []);

  // const apiData = response.data || [];

  const handleMarkAsRead = async (id) => {

    try {
      const res = await putWithTokenAPI(
        token,
        `/notifications/read/${id}`
      );

      if (res?.statusCode == 200) {
        setNotifications((prev) =>
          prev.map((n) =>
            n.id === id ? { ...n, read: true } : n
          )
        );
        if (res.data.message_code === 105 || res.data.message_code === 106 || res.data.message_code === 104 || res.data.message_code === 107) {
          if (roleType == "institution_admin") {
            navigate("/approval");
          }
          else {
            navigate(`/students`);
          }
        } else if (res.data.message_code === 103) {
          const referenceId = res.data.dynamic_content?.sender_id;
          const referencename = res.data.dynamic_content?.sender_name;
          if (roleType == "institution_admin") {
            navigate(`/message`)
          }
          else {
            navigate(`/message/${referenceId}/${referencename}`);
          }
        }
        setShowNotifications(false)
      }
    } catch (error) {
      console.error("Mark as read error", error);
    }
  };

  // Click outside to close
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        panelRef.current &&
        !panelRef.current.contains(event.target) &&
        notificationBtnRef.current &&
        !notificationBtnRef.current.contains(event.target)
      ) {
        setShowNotifications(false);
      }
    };

    if (showNotifications) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotifications]);
  const Navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const searchRef = useRef(null);
  const navItems =
    roleType === "institution_admin"
      ? [
        { id: 2, label: "Account", path: "/accounts" },
        { id: 3, label: "Messages", path: "/message" },
        { id: 7, label: "Upload", path: "/" },
        { id: 8, label: "Approval", path: "/approval" },
      ]
      : [
        { id: 8, label: "Profile", path: "/profile" },
        { id: 1, label: "Dashboard", path: "/" },
        { id: 2, label: "Students", path: "/students" },
        { id: 3, label: "Institutions", path: "/institutions" },
        { id: 4, label: "Messages", path: "/message" },
      ];
  const filteredNavItems = navItems.filter((item) =>
    item.label.toLowerCase().includes(searchText.toLowerCase()),
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSearchDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const currentDate = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  // useEffect(() => {
  //   if (roleType !== "institution_admin") return;

  //   const fetchProfile = async () => {
  //     try {
  //       const updateRes = await getWithTokenAPI(
  //         token,
  //         `${students_profile}${userId}`,
  //       );

  //       if (updateRes?.statusCode === 200) {
  //         setInstitutionprofile(updateRes.data);
  //       }
  //     } catch (error) {
  //       console.log("Failed to update phone number");
  //     }
  //   };

  //   fetchProfile();
  // }, [roleType, token, userId]);

  const fetchAdminProfile = async () => {
    const res = await getWithTokenAPI(token, `${students_profile}${userId}`);

    console.log(res, 'resres')
    if (res?.statusCode === 200) {
      dispatch(
        setProfileData({
          name: roleType == "institution_admin" ? res.data.nameofInstitution : res.data.name,
          phone: res.data.phoneNumber,
          role: res.data.roleType,
          price: res.data.adminPrice,
          profileImage: roleType == "institution_admin" ? res.data.logo : res.data.profile_img,
          subexams :res.data.subexams,
          exams :res.data.exams
        }),
      );
    }
  };

  useEffect(() => {
    fetchAdminProfile();
  }, []);

  const profile = useSelector((state) => state.profile);
  
  useEffect(() => {
    if (showNotifications) {
      // lock background scroll
      document.body.style.overflow = "hidden";
    } else {
      // unlock background scroll
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [showNotifications]);

  return (
    <>
      <header
        className="topbar"
        style={{
          marginLeft: isSidebarCollapsed ? "60px" : "280px",
          transition: "margin-left 0.3s",
        }}
      >
        {/* {Institutionprofile?.nameofInstitution && ( */}
        <div>
          <p className="institution-title-topbar">
            {profile?.name}
          </p>
        </div>
        {/* )} */}
        <div className="topbar-left">
          <div className="search-wrapper" ref={searchRef}>
            <div className="search-box-top">
              <Search size={18} className="search-icon" />
              <input
                type="text"
                placeholder="Search here..."
                className="search-input"
                value={searchText}
                onChange={(e) => {
                  setSearchText(e.target.value);
                  setShowSearchDropdown(true);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && filteredNavItems.length > 0) {
                    navigate(filteredNavItems[0].path);
                    setShowSearchDropdown(false);
                    setSearchText("");
                  }
                }}
              />
            </div>
            {showSearchDropdown && searchText && (
              <div className="search-dropdown" ref={searchRef}>
                {filteredNavItems.length > 0 ? (
                  filteredNavItems.map((item) => (
                    <div
                      key={item.id}
                      className="search-dropdown-item"
                      onClick={() => {
                        navigate(item.path);
                        setSearchText("");
                        setShowSearchDropdown(false);
                      }}
                    >
                      {item.label}
                    </div>
                  ))
                ) : (
                  <div className="search-dropdown-item no-result">
                    No results found
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="topbar-right">
          {roleType === "superadmin" ? (
            <div className="user-profile-wrapper" style={{ display: 'flex', gap: "10px" }}>
              <button
                className="user-profile-btn"
                onClick={() => navigate("/profile")}
              >
                <div className="user-avatar">
                  {profile?.profileImage ? (
                    <img
                      src={profile?.profileImage}
                      alt="Profile"
                      className="user-profile-image"
                    />
                  ) : (
                    <User size={20} />
                  )}
                </div>

                <div className="user-info">
                  <span className="user-name">{profile?.name || "Admin"}</span>
                  <span className="user-role">{profile.role}</span>
                </div>
                {showUserMenu ? (
                  <ChevronUp size={16} className="user-info-icons" />
                ) : (
                  <ChevronDown size={16} className="user-info-icons" />
                )}
              </button>
              <button
                className="notification-btn"
                onClick={() => setShowNotifications(!showNotifications)}
              >
                <Bell size={20} />
                {unreadCount > 0 && (
                  <span className="notification-badge"></span>
                )}
              </button>
            </div>
          ) : (
            <div className="notification-institution">
              <div className="notification-wrapper" ref={notificationBtnRef}>
                <button
                  className="notification-btn"
                  onClick={() => setShowNotifications(!showNotifications)}
                >
                  <Bell size={20} />
                  {unreadCount > 0 && (
                    <span className="notification-badge"></span>
                  )}
                </button>
              </div>
              <img src={profile?.profileImage} alt="Logo" className="custom-user-logo" onClick={() => navigate("/accounts")} />
            </div>
          )}
        </div>
      </header>

      {showNotifications && (
        <div
          className="notification-overlay"
          onClick={() => setShowNotifications(false)}
        />
      )}
      <div
        ref={panelRef}
        className={`notifications-panel ${showNotifications ? "open" : ""}`}
      >
        {showNotifications && (
          <NotificationsPanel
            notifications={notifications}
            unreadCount={unreadCount}
            onMarkAsRead={handleMarkAsRead}
            onClose={() => setShowNotifications(false)}
          />
        )}
      </div>
    </>
  );
};

export default TopBar;
